/* eslint-disable camelcase */
/* eslint-disable no-invalid-this */
import {makeObservable} from 'mobx';
import {removeFacets, processSettingImages, processFacetTransformers} from '../services/middleware';
import {SETTING_CLIENT_GUID, SETTING_STEP} from './constants';
import {ProductStore} from './product-store';

export class SettingStore extends ProductStore {

	type = 'setting';

	step = SETTING_STEP;

	facetTransformers = {
		price_sale: facet => {
			facet.custom = {
				...facet.custom,
				excludeTooltip: true
			};

			return facet;
		},
		rs_collections: facet => {
			facet.type = 'setting-style';

			return facet;
		},
		rs_metal_type: facet => {
			facet.type = 'setting-metal';

			facet.custom = {
				...facet.custom,
				excludeTooltip: true
			};

			return facet;
		}
	};

	allowedFacets = {
		price_sale: true,
		rs_collections: true,
		rs_metal_type: true
	};

	/**
	 * @type {import('extensions/hawksearch/services/types').SearchServiceOptions}
	 */
	searchServiceOptions = {
		...this.searchServiceOptions,
		backgroundFacets: {
			is_ring_setting: [1]
		},
		clientGuid: SETTING_CLIENT_GUID,
		middleware: {
			...this.searchServiceOptions?.middleware,
			afterSearch: [removeFacets(this.allowedFacets)],
			afterStore: [
				...this.searchServiceOptions?.middleware?.afterStore || [],
				processSettingImages,
				processFacetTransformers(this.facetTransformers)
			]
		},
		paginationSetCode: 'ringbuilder',
		queryStringParamPrefix: 's-',
		sortingSetCode: 'ringbuilder'
	};

	/**
	 * @type {import('extensions/hawksearch/services/types').SearchRequest}
	 */
	get initialProductLoaderFacets () {
		return this.product?.id || this.compareList?.length > 0
			? {
				backgroundFacets: {
					unique_id: [
						...this.product?.id
							? [this.product?.id]
							: [],
						...this.compareList?.length > 0
							? this.compareList
							: []
					]
				}
			}
			: void 0;
	}

	/**
	 * @param {import('extensions/hawksearch/services/types').SearchResultsItem} diamondProduct
	 * @returns {import('extensions/hawksearch/services/types').SearchRequest}
	 */
	compatabilityParams (diamondProduct) {
		return {
			backgroundFacets: {
				compatible_diamonds: [diamondProduct?.attributes?.formatted_diamond_value]
			}
		};
	}

	constructor ({parentStore}) {
		super(parentStore);

		this.searchService = this.createSearchService();

		makeObservable(this, {});
	}

};

